<ada-container
	#MainElement
	horizontalSpacing="Small"
	verticalSpacing="Small"
	[colCount]="4"
>
	<ada-text
		content="Part"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.part || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Vendor"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.vendor || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Product"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.product || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Version"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.version || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Update"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.update || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Edition"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.edition || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Language"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.language || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Software Edition"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.swEdition || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Target Hardware"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.targetHw || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Target Software"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.targetSw || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
	<ada-text
		content="Other"
		fontWeight="Bold"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	></ada-text>
	<ada-text
		content="{{cpeInfo?.other || '--'}}"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	></ada-text>
</ada-container>
